exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-horizontal-scroll-type[data-v-45de51ca]{height:100px;position:absolute;opacity:0;overflow-x:scroll;width:100px}.ebx-horizontal-scroll-type__scroll[data-v-45de51ca]{height:100%;width:200px}", ""]);
